import GroupedSlaBarChart, {
  GroupedSlaChartConfig,
} from "./GroupedSlaBarChart";

interface IProps {
  data: any;
  startDate?: string;
  endDate?: string;
  teamId?: string | null;
  workflowId?: string | null;
}

const TAG_CONFIG: GroupedSlaChartConfig = {
  title: "Customer tags SL",
  modalSubtitle: "All tags — Within SL, Breaches and count",
  emptyLabel: "customer tags SL",
  sampleCategories: ["FPremium", "VVIP", "Platinum", "TSI"],
  colorPalette: [
    { dark: "#2563eb", light: "#93c5fd" },
    { dark: "#7c3aed", light: "#c4b5fd" },
    { dark: "#16a34a", light: "#86efac" },
    { dark: "#b45309", light: "#fcd34d" },
    { dark: "#db2777", light: "#f9a8d4" },
    { dark: "#ea580c", light: "#fdba74" },
  ],
  apiArrayKeys: [
    "tag_sl_graph",
    "daily_tag_resolution_sla",
    "tag_resolution_sla_daily",
    "tag_wise_resolution_sla",
    "resolution_sla_by_tag",
    "daily_resolution_sla_by_tag",
  ],
  nestedItemKeys: ["tags", "tag_data", "data"],
  categoryNameFields: ["name", "tag", "tag_name"],
  dailyGraphFields: {
    resolvedKeys: ["tag_sl_resolved"],
    breachedKeys: ["tag_sl_breached"],
    itemResolvedKeys: ["tag_sl_resolved"],
    itemBreachedKeys: ["tag_sl_breached"],
  },
  excludedRootKeys: [
    "card_count",
    "disposition_sl_graph",
    "workflow_sl_graph",
    "average_resolution_time",
    "resolution_beyond_sla",
    "sla_met_count",
    "sla_breached_count",
    "daily_workflow_stage_resolution_sla",
    "workflow_stage_resolution_sla_daily",
    "workflow_stage_wise_resolution_sla",
    "resolution_sla_by_workflow_stage",
    "daily_resolution_sla_by_stage",
  ],
  clickToExpand: {
    graphName: "tag_sl_graph",
    categoryIdField: "tag_id",
    categoryIdParam: "tag_id",
    resolvedValue: "resolved",
    breachedValue: "breached",
  },
};

const TagWiseResolutionSLA: React.FC<IProps> = (props) => (
  <GroupedSlaBarChart {...props} config={TAG_CONFIG} />
);

export default TagWiseResolutionSLA;
